<app-header></app-header>

<div class="wrpr">
    <div class="homePageCont">

        <div class="contentCard">
            <div class="backBtnCont">
                <h2>Insights</h2>
            </div>

            <!-- Tab Navigation -->
            <div class="tab-navigation">
                <button 
                    class="tab-button" *ngIf="isCoverageReportAllowed"
                    [class.active]="activeTab === 'insights'"
                    (click)="setActiveTab('insights')">
                    Coverage Report Generation
                </button>
                <button 
                    class="tab-button" *ngIf="isPriceFXLoaderAllowed"
                    [class.active]="activeTab === 'pricefx'"
                    (click)="setActiveTab('pricefx')" >
                    PriceFX Loader
                    
                </button>
                <button 
                    class="tab-button" *ngIf="isSKUAllowed"
                    [class.active]="activeTab === 'sku'"
                    (click)="setActiveTab('sku')">
                    SKU Generator
                </button>
            </div>

            <!-- Tab Content -->
            <div class="tab-content">
                <!-- Insights Tab -->
                <div *ngIf="activeTab === 'insights'" class="tab-pane">
            <form class="coverageReportForm">
                <div class="plRegSelection">

                    <div class="formControl">
                        <label class="formLabel required" for="email">
                            Regions
                        </label>

                        <div class="toggleCont">
                            <p (click)="openReg()">{{selectedRegions().length ? selectedRegions() : 'Select Region'}}
                            </p>
                            <div class="optionsSet" *ngIf="isRegionOpen">
                                <label for="{{region.regionCode}}" class="optionBtn"
                                    [ngClass]="{'checked': selectedRegions().includes(region.regionName)}" *ngFor="let region of regions">
                                    <input type="checkbox" [checked]="selectedRegions().includes(region.regionCode)"
                                        id="{{region.regionCode}}"
                                        (change)="toggleRegionSelection(region.regionName)" />
                                    {{ region.regionName }}
                                </label>
                            </div>
                        </div>
                        <img src="/assets/images/chevron-south.svg" (click)="openReg()" alt="email-icon"
                            class="emailIcon">
                    </div>
                    <div class="formControl">
                        <label class="formLabel required" for="email">
                            Product Line
                        </label>
                        <div class="toggleCont" [class.disabled]="isPLDisabled">
                            <p (click)="openPL()">{{selectedProductLineIds().length ? selectedProductLineIds() : 'Select
                                Productline'}}</p>
                            <div class="optionsSet" *ngIf="isPLOpen">
                                <label for="{{productLine.code}}" class="optionBtn"
                                    [ngClass]="{'checked': selectedProductLineIds().includes(productLine.description)}"
                                    *ngFor="let productLine of productLines">
                                    <input type="checkbox"
                                        [checked]="selectedProductLineIds().includes(productLine.description)"
                                        id="{{productLine.code}}"
                                        (change)="togglePLSelection(productLine.description)" />
                                    {{ productLine.description }}
                                </label>
                            </div>
                        </div>
                        <img (click)="openPL()" src="/assets/images/chevron-south.svg" alt="email-icon"
                            class="emailIcon">
                    </div>
                </div>
                <div class="reqSelectionCont">
                    <h3>Select 2 pairing reports to Generate a Coverage Report</h3>
                    <div class="formControl">
                        <label class="formLabel required" for="email">
                            Pairing Request 01
                        </label>
                        <div class="toggleCont" [class.disabled]="isPR1Disabled">
                            <p (click)="openPR1()"><span *ngIf="selectedPR1()">{{selectedPR1()?.requestId}}</span>
                                &nbsp;&nbsp;{{selectedPR1()?.label || 'Select a pairing request'}}</p>
                            <div class="optionsSet" *ngIf="isPR1Open">
                                <label for="{{pairReq.requestId}}" class="optionBtn"
                                    [ngClass]="{'checked': selectedPR1()?.requestId === pairReq.requestId}"
                                    *ngFor="let pairReq of requstList">
                                    <input type="radio" name="pr1" id="{{pairReq.requestId}}"
                                        [value]="pairReq.requestId"
                                        [checked]="selectedPR1()?.requestId === pairReq.requestId"
                                        (change)="togglePR1Selection(pairReq.requestId); $event.stopPropagation()" />
                                    <p><span>{{ pairReq.requestId }}</span>{{ pairReq.label }}</p>
                                </label>
                            </div>
                        </div>
                        <img (click)="openPR1()" src="/assets/images/chevron-south.svg" alt="email-icon"
                            class="emailIcon">
                    </div>
                    <div></div>
                    <div class="formControl">
                        <label class="formLabel required" for="email">
                            Pairing Request 02 <span>(Select an existing report from dropdown OR Upload New)</span>
                        </label>
                        <div class="toggleCont" [class.disabled]="isPR2Disabled">
                            <p (click)="openPR2()"><span
                                    *ngIf="selectedPR2()">{{selectedPR2()?.requestId}}</span>&nbsp;&nbsp;{{selectedPR2()?.label
                                || 'Select a pairing request'}}</p>
                            <div class="optionsSet" *ngIf="isPR2Open">
                                <label for="{{pairRequest.requestId}}" class="optionBtn"
                                    *ngFor="let pairRequest of requstList">
                                    <input type="checkbox" id="{{pairRequest.requestId}}"
                                        (change)="togglePR2Selection(pairRequest.requestId)" />
                                    <p><span>{{pairRequest.requestId}}</span>{{ pairRequest.label }}</p>
                                </label>
                            </div>
                        </div>
                        <img (click)="openPR2()" src="/assets/images/chevron-south.svg" alt="email-icon"
                            class="emailIcon">
                        <p class="separater">OR</p>
                        <div class="download_file_section">
                            <div>
                                <div class="file_name">Pairing Request Template</div>
                            </div>

                            <div onKeyPress="" (click)="downloadPriceFXFile()" style="cursor: pointer;">
                                <img class="download-icon" src="../../assets/images/download.svg" alt="download_icon" />
                            </div>
                        </div>
                        <div class="prUpload" style="border: dashed 1px var(--btn-green) !important;
                        border-radius: 0px !important;
                        background-color: #4db6ac0d !important;">
                            <label for="prFile" class="upload-custom-text" style="color: #4db6ac; font-weight: bolder;">
                                UPLOAD
                            </label>
                            <input type="file" id="prFile" #fileInput name="filename" class="prUploadBtn"
                                (change)="onFileSelected($event)">
                        </div>
                        <div class="progress_div" *ngIf="isFileUploaded">
                            <div class="progress">
                                <div class="progress-bar active" aria-valuenow="40" aria-valuemin="0"
                                    aria-valuemax="100" style="width: 100%"></div>
                            </div>
                            <div>100%</div>
                        </div>
                        <div class="file_name_div">
                            {{ fileName }}
                        </div>
                        <div class="file_name_div" *ngIf="getFileSize">
                            <div class="file_size">
                                Size:
                                <span>{{ getFileSize | formatFileSize : true }}</span>
                            </div>
                        </div>
                        <div class="validation" *ngIf="errorFlag">
                            <img src="../../assets/images/warning.svg" alt="warning-icon" /><span>{{ fileError }}</span>
                        </div>

                        <div class="success_msg" *ngIf="isFileUploaded">
                            <img src="../../assets/images/sucess-icon.svg" alt="success-icon" width="18px"
                                height="18px" />
                            File uploaded successfully
                        </div>
                    </div>
                </div>
                <div class="ctaCont">
                    <button class="primary" type="button" (click)="reqSubmit()" [disabled]="isSubmitDisabled">
                        GENERATE COVERAGE REPORT
                    </button>
                </div>
            </form>
            <div class="iFrameCont">
                <section>
                    <mat-progress-bar mode="indeterminate" style="position: absolute;"></mat-progress-bar>
                </section>
                <div class="loaderCont">
                    <div class="loaderContent" *ngIf="isReportVisible">
                        <div id="report-container" style="height: 800px;width: 100%;"></div>
                    </div>
                </div>
            </div>
                </div>

                <!-- PriceFX Loader Tab -->
                <div *ngIf="activeTab === 'pricefx'" class="tab-pane">
                    <app-pricefx-loader></app-pricefx-loader>
                </div>

                <!-- SKU Generator Tab -->
                <div *ngIf="activeTab === 'sku'" class="tab-pane">
                    <app-sku-generator></app-sku-generator>
                </div>
            </div>
        </div>
    </div>
</div>
<app-toast [message]="popupMessage" [isSuccess]="isSuccessToast" *ngIf="isShowErrorMessageWithToast"></app-toast>